/**
 * Static FollowupQuestionVersion v7 question set.
 *
 * Used only by the stub provider / preview harness so QA can click through
 * every modal state without a backend. The live flow is served by the BE via
 * `ChatService` and does NOT read this file.
 *
 * deterministic instead of relying on single.vue's answer-count heuristic.
 * Keep in sync with the BE v7 definition if you rely on it for previews.
 */
export default [
  {
    id: 1,
    title: 'Hi @firstname',
    question:
      'In order to continue your treatment, your doctor would like you to answer the following questions.',
    doctordisplay: 'Would you like to continue your treatment at the current dose?',
    hideondoctordisplay: true,
    answertype: 'single',
    displaymode: 'cta',
    answerlist: [{ id: 'continue', name: 'Continue', displaytype: 'button' }],
    next: 1.1,
  },
  {
    id: 1.1,
    question: 'Has anything changed with your medical history?',
    header: '',
    answertype: 'single',
    displaymode: 'circle',
    answerlist: [
      { id: true, name: 'Yes', next: 1.2, inline: true },
      { id: false, name: 'No' },
    ],
    next: 2,
  },
  {
    id: 1.2,
    question: 'What has changed?',
    header: '',
    allowempty: false,
    answertype: 'text',
    placeholder: '',
    next: 2,
  },
  {
    id: 2,
    question: 'Would you like to continue your treatment at the current dose?',
    header: '',
    answertype: 'single',
    displaymode: 'stack',
    answerlist: [
      { id: true, name: 'Yes', next: 7 },
      { id: false, name: 'No' },
      { id: 'not-sure', name: "I'm not sure", inline: true, next: 2.1 },
    ],
    next: 3,
  },
  {
    id: 2.1,
    question: 'Not sure whether to continue at the current dose',
    header: '',
    allowempty: true,
    answertype: 'text',
    placeholder: "Share what's on your mind so your doctor can help",
    next: 7,
  },
  {
    id: 3,
    question: 'Are you having any side effects?',
    header: '',
    answertype: 'single',
    displaymode: 'circle',
    answerlist: [
      { id: true, name: 'Yes', next: 3.1, inline: true },
      { id: false, name: 'No' },
    ],
    next: 3.3,
  },
  {
    id: 3.1,
    question: 'What are the side effects?',
    header: '',
    allowempty: false,
    answertype: 'text',
    placeholder: '',
    next: 3.2,
  },
  {
    id: 3.2,
    question: 'Is there anything else about the treatment that is not meeting your needs?',
    header: '',
    allowempty: false,
    answertype: 'text',
    placeholder: '',
    next: 7,
  },
  {
    id: 3.3,
    question: 'What about the treatment is not meeting your needs?',
    header: '',
    allowempty: false,
    answertype: 'text',
    placeholder: '',
    next: 7,
  },
  {
    id: 4,
    question: 'Is the dosage strong enough?',
    header: '',
    answertype: 'single',
    displaymode: 'circle',
    answerlist: [
      { id: true, name: 'Yes' },
      { id: false, name: 'No', next: 4.1 },
    ],
    next: 5,
  },
  {
    id: 4.1,
    title: 'Ok, the doctor may be able to increase the strength of your dosage.',
    description: '',
    type: 'modal',
    answertype: 'single',
    displaymode: 'cta',
    answerlist: [{ id: 'continue', name: 'Continue' }],
    next: 5,
  },
  {
    id: 5,
    question: 'What else could make your treatment better?',
    formedicalreview: true,
    header: '',
    allowempty: false,
    answertype: 'text',
    placeholder: '',
    next: 7,
  },
  {
    id: 7,
    question: 'Is there anything else the doctor should know?',
    header: '',
    answertype: 'single',
    displaymode: 'circle',
    consideredascompleted: true,
    answerlist: [
      { id: true, name: 'Yes', next: 7.1, inline: true },
      { id: false, name: 'No' },
    ],
    next: 8,
  },
  {
    id: 7.5,
    question: 'Is there anything else the doctor should know?',
    header: '',
    answertype: 'single',
    displaymode: 'circle',
    consideredascompleted: true,
    answerlist: [
      { id: true, name: 'Yes', next: 7.6, inline: true },
      { id: false, name: 'No' },
    ],
    next: 8.5,
  },
  {
    id: 7.1,
    question: 'What would you like for the doctor to know?',
    header: '',
    allowempty: false,
    answertype: 'text',
    placeholder: '',
    next: 8,
  },
  {
    id: 7.6,
    question: 'What would you like for the doctor to know?',
    header: '',
    allowempty: false,
    answertype: 'text',
    placeholder: '',
    next: 8.5,
  },
  {
    id: 8.5,
    title:
      'Your doctor will reach out to see if we can adjust your treatment to better fit your needs',
    description: '',
    type: 'exitmodal',
    answertype: 'nothing',
    otherrecords: ['doctor'],
    next: -1,
  },
  {
    id: 8,
    title: 'Success! Your review has been sent to the doctor.',
    description: '',
    showrating: true,
    type: 'exitmodal',
    answertype: 'nothing',
    otherrecords: ['doctor'],
    next: -1,
  },
];
